import Backbone from 'backbone';
import UserModel from '../models/model.user';

export default Backbone.Collection.extend(null, {
  model: UserModel
});
